import { useContext, useEffect, useState } from "react";
import { useAppStore } from "../store/useAppStore";
import PopUp from "./PopUp";
import { AppContext } from "../App";
import api from "./api/api";
import FormGroup from "./form/FormGroup";

export default function FiskalyExpiringLogin() {
	const { apiSettings, config, setLoading, shop, user } = useContext(AppContext);
	const { virtualPrinters, fiskalyExpiringLoginVisible, setFiskalyExpiringLoginVisible } =
		useAppStore();
	const [drawerData, setDrawerData] = useState({
		shop_id: null,
		shop_name: "",
		pin: "",
		password: "",
		pwd_expiring_date: "",
	});
	const [location, setLocation] = useState(false);
	const [printer, setPrinter] = useState(false);
	const [diff, setDiff] = useState(false);
	const [loadingData, setLoadingData] = useState(false);

	useEffect(() => {
		if (config.virtual_printer_id) {
			const selectedPrinter = virtualPrinters.find((p) => p.id == config.virtual_printer_id);
			setPrinter(selectedPrinter || false);
		} else {
			setPrinter(false);
		}
	}, [config.virtual_printer_id, virtualPrinters]);

	useEffect(() => {
		if (!user?.id) {
			setLoadingData(false);
			setDrawerData({
				shop_id: null,
				shop_name: "",
				pin: "",
				password: "",
				pwd_expiring_date: "",
			});
			return;
		}

		if (shop?.id) loadDrawerData();
	}, [shop?.id, user?.id]);

	useEffect(() => {
		if (drawerData?.pwd_expiring_date) {
			const expDate = new Date(drawerData.pwd_expiring_date);
			const today = new Date();
			const timeDiff = expDate.getTime() - today.getTime();
			const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
			setDiff(daysDiff);
		} else {
			setDiff(false);
		}
	}, [drawerData]);

	useEffect(() => {
		if (diff !== false && diff <= 0) setFiskalyExpiringLoginVisible("error");
		else if (diff !== false && diff > 0 && diff <= 10) setFiskalyExpiringLoginVisible("alert");
	}, [diff]);

	async function loadLocation() {
		if (!printer?.location_id) return false;
		const response = await api.getProtected(
			"/fiskaly_entities_locations/get/" + printer.location_id + "/"
		);
		if (response.success == 0) {
			alert(response.error);
			return false;
		}
		setLocation(response.data);
		return response.data;
	}

	async function loadCompany(locationData) {
		if (!locationData?.company_id) return false;
		const response = await api.getProtected(
			"/fiskaly_entities_company/get/" + locationData.company_id + "/"
		);
		if (response.success == 0) {
			alert(response.error);
			return false;
		}
		return response.data;
	}

	async function loadDrawerData() {
		if (!shop?.id || !user?.id) return;
		setLoadingData(true);
		const response = await api.postProtected("/pos2/shop_fiscal_drawer/", {
			shop_id: shop.id,
		});
		setLoadingData(false);
		if (response.success == 0) {
			alert(response.error);
			return;
		}
		setDrawerData({
			shop_id: response.data?.shop_id || shop.id,
			shop_name: response.data?.shop_name || shop.name || "",
			pin: response.data?.pin || "",
			password: response.data?.password || "",
			pwd_expiring_date: response.data?.pwd_expiring_date || "",
		});
	}

	const saveData = async (e) => {
		e.preventDefault();
		const data = new FormData(e.target);
		const request = Object.fromEntries(data.entries());
		setLoading(true);
		const response = await api.postProtected("/pos2/shop_fiscal_drawer_edit/", {
			shop_id: shop.id,
			pin: request.pin || "",
			password: request.password || "",
			pwd_expiring_date: request.pwd_expiring_date || "",
		});
		if (response.success == 0) {
			setLoading(false);
			alert(response.error);
			return;
		}

		setDrawerData({
			shop_id: response.data?.shop_id || shop.id,
			shop_name: response.data?.shop_name || shop.name || "",
			pin: response.data?.pin || "",
			password: response.data?.password || "",
			pwd_expiring_date: response.data?.pwd_expiring_date || "",
		});

		const fiskalyEnabled = apiSettings?.mandant?.fiskaly == 1;
		if (fiskalyEnabled && printer?.location_id) {
			const locationData = await loadLocation();
			const company = await loadCompany(locationData);
			if (company?.id) {
				const suspend = await api.postProtected(
					"/fiskaly_entities_company/edit/" + company.id + "/",
					{ mode: "SUSPENDED" }
				);
				if (suspend.success == 0) alert(suspend.error);

				const syncResponse = await api.postProtected(
					"/fiskaly_entities_company/edit/" + company.id + "/",
					{
						pin: request.pin || "",
						password: request.password || "",
						pwd_expiring_date: request.pwd_expiring_date || "",
					}
				);
				if (syncResponse.success == 0) alert(syncResponse.error);

				const operative = await api.postProtected(
					"/fiskaly_entities_company/edit/" + company.id + "/",
					{ mode: "OPERATIVE" }
				);
				if (operative.success == 0) alert(operative.error);
			}
		}

		setLoading(false);
		if (response.success == 1) {
			setFiskalyExpiringLoginVisible("info");
		}
	};

	if (!fiskalyExpiringLoginVisible) return null;

	return (
		<PopUp
			customClass="fiskaly-popup"
			options={{
				title: "Credenziali Cassetto Fiscale",
				onClose: () => setFiskalyExpiringLoginVisible(false),
			}}
		>
			<div className="inner-content">
				{loadingData && <p className="alert">Caricamento dati cassetto fiscale...</p>}
				{!loadingData && diff === false && fiskalyExpiringLoginVisible !== "form" && (
					<p className="alert">
						I dati del cassetto fiscale non hanno una data di scadenza configurata.
					</p>
				)}
				{fiskalyExpiringLoginVisible == "info" && diff > 0 && (
					<p className="alert success">
						I dati di autenticazione del cassetto fiscale scadranno tra {Math.abs(diff)}{" "}
						giorni
					</p>
				)}
				{fiskalyExpiringLoginVisible == "alert" && diff > 0 && (
					<p className="alert warning">
						I dati di autenticazione del cassetto fiscale scadranno tra {Math.abs(diff)}{" "}
						giorni
					</p>
				)}
				{fiskalyExpiringLoginVisible == "error" && (
					<p className="alert error">
						I dati di autenticazione del cassetto fiscale sono scaduti da{" "}
						{Math.abs(diff)} giorni
					</p>
				)}
				{(fiskalyExpiringLoginVisible == "alert" ||
					fiskalyExpiringLoginVisible == "error" ||
					fiskalyExpiringLoginVisible == "info") && (
					<button
						className="button"
						onClick={() => setFiskalyExpiringLoginVisible("form")}
					>
						Inserisci/Rinnova ora
					</button>
				)}
				{fiskalyExpiringLoginVisible == "form" && (
					<div className="fiskaly-form-card">
						<form onSubmit={saveData}>
							<div className="form fiskaly-form-grid">
								<FormGroup
									id="pin"
									name="pin"
									label="Pin"
									value={drawerData.pin}
								/>
								<FormGroup
									id="password"
									name="password"
									label="Password"
									value={drawerData.password}
								/>
								<FormGroup
									id="pwd_expiring_date"
									name="pwd_expiring_date"
									label="Data di scadenza password"
									type="date"
									value={drawerData.pwd_expiring_date}
								/>
							</div>
							<div className="fiskaly-actions">
								<button className="button" type="submit">
									Salva
								</button>
							</div>
						</form>
					</div>
				)}
			</div>
		</PopUp>
	);
}
